export function getFormattedDate(params) {
    if (params) {
      const utcTimestamp = params;
      const date = new Date(utcTimestamp);

      // Extract components
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    }
    return "";
  }

  export const dateSortComparator = (v1, v2) => {
  if (!v1 && !v2) return 0;
  if (!v1) return -1;
  if (!v2) return 1;

  const date1 = new Date(v1).getTime();
  const date2 = new Date(v2).getTime();

  return date1 - date2;
};